import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import associateServices from "../../../services";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import SvgIcon from "../../../components/svg-icon";
import './index.css'
import UnifyBalanceContent from "./unify-balance-content";

const WalletModal = props => {
    const {t} = useTranslation()
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {handleClose} = props


    const handleUserWallets = response => store.dispatch(AUTHENTICATION_ACTIONS.setUserWallets(response?.data || []))


    useEffect(() => {

        if (authenticated) {
            associateServices.getWallets({}).then(handleUserWallets)


            const bdy = document.body
            bdy.classList?.add('modal-open')

            const mdl = document.getElementById('unify-balances-modal')
            mdl.classList?.add('show')

            mdl.style.display = 'block'
            mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

            mdl.classList?.add('modal-fade')

            return () => {
                bdy.classList?.remove('modal-open')
                mdl.classList?.remove('show')

            }
        }
    }, [authenticated])


    return (
        <div
            className="modal fade"
            id="unify-balances-modal"
            tabIndex={-1}
            onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <div className="d-flex align-items-center gap-2">
                                <SvgIcon id={'wallet'}/>
                                <h6 className="modal__title">{t('unify-balances.title')}</h6>
                            </div>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>
                        <div className="tab-content">
                            <div className="tab-pane fade show active" role="tabpanel">
                                <UnifyBalanceContent/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}


export default WalletModal
